import {createReducer} from '@reduxjs/toolkit';
import omit from 'lodash.omit';
import {
    getCreditAlertSettingsFailure,
    getCreditAlertSettingsRequest,
    getCreditAlertSettingsSuccess,
} from 'src/openapi/admin/apis/AlertControllerApi';
import {
    getContractsBasicRequest,
    getContractsBasicSuccess,
} from 'src/openapi/admin/apis/ContractControllerApi';
import {
    getUsersByAccountIdRequest,
    getUsersByAccountIdSuccess,
} from 'src/openapi/admin/apis/UserControllerApi';

import {clearError} from '../actions';


import type {Contract} from 'src/openapi/admin/models/Contract';
import type {CreditAlertSettings} from 'src/openapi/admin/models/CreditAlertSettings';
import type {Error} from 'src/openapi/admin/models/Error';
import type {UserList} from 'src/openapi/admin/models/UserList';

export type State = {
    data: Record<number, CreditAlertSettings>,
    users: Record<number, UserList>,
    activeContracts: Record<number, Array<Contract>>,
    error: Error | null,
};

const defaultState: State = {
    data: {},
    users: {},
    activeContracts: {},
    error: null,
};

export const alertsData = createReducer(defaultState, builder => builder
    .addCase(getCreditAlertSettingsRequest, (state, action) => {
        const accountId = action.payload.meta.accountId;
        state.data = {
            ...omit(state.data, String(accountId)),
        };
    })
    .addCase(getCreditAlertSettingsSuccess, (state, action) => {
        const accountId = action.payload.meta.accountId;
        state.data = {
            ...state.data,
            [accountId]: action.payload.data,
        };
    })
    .addCase(getUsersByAccountIdRequest, (state, action) => {
        const accountId = action.payload.meta.accountId;
        state.users = {
            ...omit(state.users, String(accountId)),
        };
    })
    .addCase(getUsersByAccountIdSuccess, (state, action) => {
        const accountId = action.payload.meta.accountId;
        state.users = {
            ...state.users,
            [accountId]: action.payload.data,
        };
    })
    .addCase(getCreditAlertSettingsFailure, (state, action) => {
        state.error = action.payload.data;
    })
    .addCase(getContractsBasicRequest, (state, action) => {
        const accountId = action.payload.meta.accountId;
        state.activeContracts = {
            ...omit(state.activeContracts, String(accountId)),
        };
    })
    .addCase(getContractsBasicSuccess, (state, action) => {
        const accountId = action.payload.meta.accountId;
        state.activeContracts = {
            ...state.activeContracts,
            [accountId]: action.payload.data,
        };
    })
    .addCase(clearError, state => {
        state.error = null;
    }),
);
